import type { GovAccordionItemProps } from '@gov-design-system-ce/react/gov-accordion';
import { GovAccordionItem } from '@gov-design-system-ce/react/gov-accordion';

interface AccordionItemProps extends Omit<
	GovAccordionItemProps,
	'open' | 'disabled'
> {
	isOpen?: boolean;
	isDisabled?: boolean;
}

export const AccordionItem = ({
	children,
	className,
	isOpen,
	isDisabled,
	...props
}: AccordionItemProps) => (
	<GovAccordionItem
		open={isOpen}
		disabled={isDisabled}
		className={className}
		{...props}>
		{children}
	</GovAccordionItem>
);
